import { render } from "./SettingsBarBtn.vue?vue&type=template&id=42b40e94&scoped=true"
import script from "./SettingsBarBtn.vue?vue&type=script&lang=js"
export * from "./SettingsBarBtn.vue?vue&type=script&lang=js"

import "./SettingsBarBtn.vue?vue&type=style&index=0&id=42b40e94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b40e94"]])

export default __exports__